// Prevent users creating azure MSH account from 
// copying and pasting into confirm email address field
var confirmEmailField = document.getElementById('reenterEmail');

if(confirmEmailField) {
    confirmEmailField.addEventListener('paste', function (e) {
        e.preventDefault();
    });
}